export default [
  {
    value: '0.0',
    label: '不限'
  },
  {
    value: '14.0',
    label: 'iOS 14.0及以上'
  },
  {
    value: '13.3',
    label: 'iOS 13.3及以上'
  },
  {
    value: '13.2',
    label: 'iOS 13.2及以上'
  },
  {
    value: '13.1',
    label: 'iOS 13.1及以上'
  },
  {
    value: '13.0',
    label: 'iOS 13.0及以上'
  },
  {
    value: '12.4',
    label: 'iOS 12.4及以上'
  },
  {
    value: '12.3',
    label: 'iOS 12.3及以上'
  },
  {
    value: '12.2',
    label: 'iOS 12.2及以上'
  },
  {
    value: '12.1',
    label: 'iOS 12.1及以上'
  },
  {
    value: '12.0',
    label: 'iOS 12.0及以上'
  },
  {
    value: '11.4',
    label: 'iOS 11.4及以上'
  },
  {
    value: '11.3',
    label: 'iOS 11.3及以上'
  },
  {
    value: '11.2',
    label: 'iOS 11.2及以上'
  },
  {
    value: '11.1',
    label: 'iOS 11.1及以上'
  },
  {
    value: '11.0',
    label: 'iOS 11.0及以上'
  },
  {
    value: '10.3',
    label: 'iOS 10.3及以上'
  },
  {
    value: '10.2',
    label: 'iOS 10.2及以上'
  },
  {
    value: '10.1',
    label: 'iOS 10.1及以上'
  },
  {
    value: '9.3',
    label: 'iOS 9.3及以上'
  },
  {
    value: '9.2',
    label: 'iOS 9.2及以上'
  },
  {
    value: '9.1',
    label: 'iOS 9.1及以上'
  },
  {
    value: '9.0',
    label: 'iOS 9.0及以上'
  },
  {
    value: '8.2',
    label: 'iOS 8.2及以上'
  },
  {
    value: '8.1',
    label: 'iOS 8.1及以上'
  },
  {
    value: '8.0',
    label: 'iOS 8.0及以上'
  },
  {
    value: '7.1',
    label: 'iOS 7.1及以上'
  },
  {
    value: '7.0',
    label: 'iOS 7.0及以上'
  },
  {
    value: '6.0',
    label: 'iOS 6.0及以上'
  },
  {
    value: '5.1',
    label: 'iOS 5.1及以上'
  },
  {
    value: '5.0',
    label: 'iOS 5.0及以上'
  },
  {
    value: '4.3',
    label: 'iOS 4.3及以上'
  },
  {
    value: '4.2',
    label: 'iOS 4.2及以上'
  },
  {
    value: '4.1',
    label: 'iOS 4.1及以上'
  },
  {
    value: '4.0',
    label: 'iOS 4.0及以上'
  }
]
